<template>
    <!--Footer section-->
    <section class="sales-footer">
        <div class="sales-footer-main-wrapper">
            <div class="image-logo">
                <a href="https://twitter.com/ringmystylist" target="_blank"
                    ><img src="../../assets/images/twitter-x.png" alt="Twitter Logo"
                /></a>
            </div>
            <div class="image-logo">
                <a href="https://www.linkedin.com/company/ringmystylist/" target="_blank"
                    ><img src="../../assets/images/linkedin.png" alt="LinkedIn Logo"
                /></a>
            </div>
            <div class="image-logo">
                <a href="https://www.youtube.com/@RingMyStylist" target="_blank"
                    ><img src="../../assets/images/youtube.png" alt="Youtube Logo"
                /></a>
            </div>
            <div class="image-logo">
                <a href="https://www.instagram.com/ringmystylist" target="_blank"
                    ><img src="../../assets/images/instagram.png" alt="Instagram Logo"
                /></a>
            </div>
            <div class="image-logo">
                <a href="https://www.tiktok.com/@ringmystylist" target="_blank"
                    ><img src="../../assets/images/tik-tok.png" alt="TikTok Logo"
                /></a>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: "SalesFooter",

    data: function () {
        return {};
    },
    mounted: function () {},
    computed: {},
};
</script>
